import { combineReducers } from '@reduxjs/toolkit';

import cncUiReducer from './cncUiSlice';
import debugReducer from './debugSlice';
import sharedUiReducer from './sharedUiSlice';

const combined = combineReducers({
    cnc: cncUiReducer,
    shared: sharedUiReducer,
    debug: debugReducer,
});

export default combined;
